import React from 'react';
import { PageHeader } from '../../components/admin/PageHeader';
import { RoadmapContent } from '../../components/presentation/RoadmapContent';
export function FutureRoadmap() {
  return <div data-id="element-1098" data-mp="1brp0lbk232zq">
      <PageHeader title="ভবিষ্যৎ সম্প্রসারণ" subtitle="পর্যায়ভিত্তিক রোডম্যাপ — ভবিষ্যৎ বৈশিষ্ট্য, বর্তমান কার্যকারিতা নয়" data-id="element-1099" data-mp="1brysx5skpm8l" />
      <RoadmapContent data-id="element-1100" data-mp="1gop71nkti7rd" />
    </div>;
}